// extracted by mini-css-extract-plugin
export default {"grid":"HeaderLinks_grid__zonyW","cell":"HeaderLinks_cell__+aJXz","clickable":"HeaderLinks_clickable__GvHv+"};